import React from 'react';

function LoaderButton() {
    return (
        <div className="transition-loader-btn">
            <label/>
            <label/>
            <label/>
            <label/>
            <label/>
            <label/>
        </div>
    )
}

export default LoaderButton;